var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9529 7.97142C19.0157 8.15766 19.0157 8.35936 18.9529 8.5456C17.7066 12.2953 14.1689 15 9.99959 15C5.83204 15 2.29618 12.298 1.04717 8.55009C0.984275 8.36409 0.984275 8.16281 1.04717 7.97591C2.29259 4.22619 5.83024 1.52151 9.99959 1.52151C14.1671 1.52151 17.7039 4.2235 18.9529 7.97142Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30392 8.26133C7.30392 7.54639 7.58793 6.86073 8.09347 6.35519C8.59901 5.84964 9.28467 5.56563 9.99961 5.56563C10.7146 5.56563 11.4002 5.84964 11.9058 6.35519C12.4113 6.86073 12.6953 7.54639 12.6953 8.26133C12.6953 8.97628 12.4113 9.66194 11.9058 10.1675C11.4002 10.673 10.7146 10.957 9.99961 10.957C9.28467 10.957 8.59901 10.673 8.09347 10.1675C7.58793 9.66194 7.30392 8.97628 7.30392 8.26133Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/ShowIcon.c771a795c8eff72c09627004651183a0.svg";
export { ForwardRef as ReactComponent };